import {config} from "../../../../../config";

declare global {
    interface Window {
        lintrk: any;
        _linkedin_data_partner_ids: string[];
    }
}

const LINKEDIN_PARTNER_ID = process.env.LINKEDIN_PARTNER_ID;

export class SedestralProactiveLinkedin {

    static init(): void {
        if (config.isWhiteLabel) return;
        if (!LINKEDIN_PARTNER_ID || LINKEDIN_PARTNER_ID === '') {
            console.debug('LinkedIn Partner ID not configured, skipping initialization');
            return;
        }

        try {
            this.initInsightTag();
        } catch (err) {
            console.error('Failed to initialize LinkedIn Insight Tag:', err);
        }
    }

    private static initInsightTag(): void {
        if (window.lintrk) return;

        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);

        const lintrk: any = window.lintrk = function (action: string, data: any) {
            lintrk.q.push([action, data]);
        };
        lintrk.q = [];

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }
    }
}
